<div class="content-top clearfix">
  <h1 class="al-title">{{ activePageTitle }}</h1>

  <ul class="breadcrumb al-breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/pages/dashboard">Home</a></li>
    <li class="breadcrumb-item active">{{ activePageTitle }}</li>
  </ul>
</div>
